import React from 'react';
import styles from './Panel.module.css';

interface PanelProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

const Panel: React.FC<PanelProps> = ({ title, children, className }) => {
  return (
    <div className={`${styles.panel} ${className || ''}`}>
      {title && (
        <div className={styles.header}>
          <h3 className={styles.title}>{title}</h3>
        </div>
      )}
      <div className={styles.content}>{children}</div>
    </div>
  );
};

export default Panel;
